module.exports = __webpack_public_path__ + "static/media/PLT_LOGO_BLACK.86707d33.png";